/* eslint-disable camelcase */
import _ from 'lodash';
import { RepositoryFactory } from '../../../repositories/RepositoryFactory';
import { getVirtualCardData } from '../../../repositories/mockDataUtils';
import {
  checkProductsIsEVoucher,
  checkProductsIsCoupon,
  checkProductsIsMonoEVoucher,
  checkProductsIsOpenEVoucher,
  checkProductIsNDE,
  checkProductIsNDEOwnDistribution,
  checkProductIsNDEExternalDistribution,
  checkProductIsPhysicalNDE,
  checkProductIsVirtualNDE,
  checkProductsIsPhysicalCard,
  checkProductsIsVirtualCard,
} from '../../../utils/categoryUtils';
import { types } from './mutation-types';

const shop = RepositoryFactory.get('products');

export const products = {
  namespaced: false,
  state: {
    all: [],
    additional: [],
    additionalId: 0,
    loaded: false,
  },
  getters: {
    deliveriesProducts: state => (deliveryId) => {
      let productArray;
      const allProducts = state.all.products;

      if (deliveryId === 0) {
        productArray = allProducts;
      } else {
        productArray = allProducts.filter(product => product.product_category !== 'AD');
      }
      if (typeof state.additional[deliveryId] !== 'undefined') {
        if (state.additional[deliveryId] !== null) productArray = [...productArray, ...state.additional[deliveryId]];
      }
      return _.orderBy(productArray, 'price', 'asc');
    },
    allProducts: state => state.all.products,
    allProductsFlat: (state) => {
      const { products: allProducts, delivery_fee: deliveryPointsCount } = state.all;
      const flatProducts = (allProducts || []).reduce((acc, product) => {
        if (Array.isArray(product.confection)) {
          acc.push(...product.confection);
        }
        if (Array.isArray(product.confectionService)) {
          acc.push(...product.confectionService);
        }
        acc.push(product);
        return acc;
      }, []);

      return [
        deliveryPointsCount,
        ...flatProducts,
      ];
    },
    additionalProductsFlat: (state) => {
      const productsPerDelivery = Array.isArray(state.additional) ? state.additional : [];
      return productsPerDelivery.reduce((acc, productList) => {
        if (Array.isArray(productList)) acc.push(...productList.filter(Boolean));
        return acc;
      }, []);
    },
    getProductType: state => state.all.products[0].product_category,
    getType: state => state.all.products[0].product_type,
    getProductLoaded: state => state.loaded,
    getPromoProducts: state => state.all.promo,
    getDeliveryAddressProduct: state => state.all.delivery_fee,
    isProductEVoucher: state => checkProductsIsEVoucher(state.all.products[0]),
    isProductPhysicalCard: state => checkProductsIsPhysicalCard(state.all.products[0]),
    isProductVirtualCard: state => checkProductsIsVirtualCard(state.all.products[0]),
    isProductNDE: state => checkProductIsNDE(state.all.products[0]),
    isProductPhysicalNDE: state => checkProductIsPhysicalNDE(state.all.products[0]),
    isProductVirtualNDE: state => checkProductIsVirtualNDE(state.all.products[0]),
    isProductNDEOwnDistribution: state => checkProductIsNDEOwnDistribution(state.all.products[0]),
    isProductNDEExternalDistribution: state => checkProductIsNDEExternalDistribution(state.all.products[0]),
    isProductsMonoEVoucher: state => checkProductsIsMonoEVoucher(state.all.products[0]),
    isProductsOpenEVoucher: state => checkProductsIsOpenEVoucher(state.all.products[0]),
    isProductCoupon: state => checkProductsIsCoupon(state.all.products[0]),
  },
  actions: {
    async getAllProducts({ commit, dispatch }, contractId) {
      try {
        const response = await shop.getProducts(contractId);
        const {
          contract,
          delivery_fee,
          products: responseProducts,
          promo,
        } = response.data;
        commit(types.SET_PRODUCTS, { products: responseProducts, delivery_fee, promo });
        dispatch('customer/setCustomerContract', contract, { root: true });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error.message);
      }
    },
    async getFakeProduct({ commit }) {
      const fakeProduct = await getVirtualCardData;
      try {
        commit(types.SET_PRODUCTS, fakeProduct);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
    updateProduct({ commit }, product) {
      commit(types.UPDATE_PRODUCT, product);
    },
    addProduct({ commit }, params) {
      commit(types.ADD_PRODUCT, params);
    },
    removeProduct({ commit }, params) {
      commit(types.REMOVE_PRODUCT, params);
    },
    removeAdditionalProduct({ commit }, productId) {
      commit(types.REMOVE_ADDITIONAL_PRODUCT, productId);
    },
    copyAdditional({ commit }, props) {
      commit(types.COPY_ADDITIONAL_PRODUCT, props);
    },
    resetProduct({ commit }) {
      commit(types.RESET_PRODUCT);
    },
    resetAllProducts({ commit }) {
      commit(types.RESET);
    },
  },
  mutations: {
    // eslint-disable-next-line no-shadow
    [types.SET_PRODUCTS](state, products) {
      state.all = products;
      state.loaded = true;
    },
    [types.UPDATE_PRODUCT](state, product) {
      const index = state.all.findIndex(item => item.idproducts === product.idproducts);
      if (index !== -1) state.all.splice(index, 1, product);
    },
    [types.ADD_PRODUCT](state, params) {
      // eslint-disable-next-line no-plusplus
      const productParams = params;
      // eslint-disable-next-line no-plusplus
      const itemId = state.additionalId++;

      if (typeof state.additional[productParams[1]] === 'undefined') {
        productParams[0].idproducts = `${productParams[0].idproducts}-${itemId}`;
        state.additional[productParams[1]] = [productParams[0]];
      } else {
        productParams[0].idproducts = `${productParams[0].idproducts}-${itemId}`;
        state.additional[productParams[1]].push(productParams[0]);
      }
      // this is for vue reaction
      state.additional.push('reactive');
      state.additional.splice(-1, 1);
    },
    [types.REMOVE_PRODUCT](state, params) {
      // let index = state.additional[params[1]].indexOf(params[0].idproducts);
      const index = state.additional[params[1]].findIndex(item => item.idproducts === params[0].idproducts);
      state.additional[params[1]].splice(index, 1);
      // this is for vue reaction
      state.additional.push('reactive');
      state.additional.splice(-1, 1);
    },
    [types.REMOVE_ADDITIONAL_PRODUCT](state, productId) {
      const productsPerDelivery = Array.isArray(state.additional) ? state.additional : [];

      state.additional = productsPerDelivery.map(productList => (
        Array.isArray(productList)
          ? productList.filter(p => p && p.idproducts !== productId)
          : productList
      ));

      state.additional.push('reactive');
      state.additional.splice(-1, 1);
    },
    // eslint-disable-next-line camelcase
    [types.COPY_ADDITIONAL_PRODUCT](state, props) {
      // eslint-disable-next-line prefer-destructuring
      state.additional[props[1]] = state.additional[props[0]];
    },
    [types.RESET_PRODUCT](state) {
      state.additional = [];
    },
    [types.RESET](state) {
      state.additional = [];
      state.all = [];
      state.additionalId = 0;
      state.loaded = false;
    },
  },
};
